import inMemoryJwt from './inMemoryJwtService';

const formRequestData = (method: string, addAuthorization: boolean, credentials?: {}, data?: {}) => {
    let requestData: any = {
        headers: {}
    }

    requestData.method = method;

    if (addAuthorization) {
        requestData.headers['Authorization'] = `JWT ${inMemoryJwt.getToken()}`;
    }

    // if (credentials) {
    //     debugger;
    //     requestData.credentials = credentials;
    //     requestData.origin="http://localhost:8000"
    // }

    if (data) {
        requestData.headers['Content-Type'] = "application/json";
        requestData.body = JSON.stringify(data);
    }

    return requestData;
}

const ajaxCall = async (url: string, data: {}) => {
    const response = await fetch(url, data);
    
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message);
    }

    return response.json();
}

export {
    formRequestData,
    ajaxCall
}